import { createFileRoute } from "@tanstack/react-router";

import { InvitePage } from "@/features/invitee";

export const Route = createFileRoute("/(member)/(public)/invite/$token/")({
  component: InvitePage,
  head: () => ({
    meta: [
      { title: "Birdwatch - Accept Invite" },
      {
        name: "description",
        content: "Accept your Birdwatch household invite",
      },
    ],
  }),
});
